import { getInsuranceDestinationCountriesFromOrder } from 'lib/order/orderInsuranceUtils'
import { createSelector } from 'reselect'

const getInsuranceDestinationCountriesFromExistingOrder = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.cruise.cruiseOfferSnapshot,
  (state: App.State) => state.offer.offers,
  (order, cruiseOfferSnapshots, offers): Array<string> => {
    if (order) {
      return getInsuranceDestinationCountriesFromOrder(order, cruiseOfferSnapshots, offers)
    }

    return []
  },
)

export default getInsuranceDestinationCountriesFromExistingOrder
